import React from 'react';
import ReactDOM from 'react-dom';

import '../lib/react-intl-use-intl-shim.js';
import HomePage from '../components/home/home-page.jsx';

export default appTarget => {
    ReactDOM.render(<HomePage />, appTarget);
};
